import React, { useEffect, useMemo, useState } from 'react';
import './WorkflowPratica.css';

const tipiVisibili = ['CREAZIONE', 'STATO', 'SCADENZA', 'DOCUMENTO', 'PAGAMENTO'];
const etichetteTipo = {
  CREAZIONE: 'Creazione',
  STATO: 'Cambio stato',
  SCADENZA: 'Scadenza',
  DOCUMENTO: 'Documento',
  PAGAMENTO: 'Pagamento'
};

export default function WorkflowPratica({ schedaId, onDirtyChange, onStatusChange }) {
  const [data, setData] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => { onDirtyChange?.(false); }, [onDirtyChange]);

  useEffect(() => {
    if (!schedaId) return;
    let active = true;
    setError('');
    fetch(`/api/workflow/schede/${schedaId}`)
      .then(response => {
        if (!response.ok) throw new Error('Impossibile caricare lo storico');
        return response.json();
      })
      .then(result => {
        if (!active) return;
        setData(result);
        onStatusChange?.(result.stato);
      })
      .catch(err => { if (active) setError(err.message); });
    return () => { active = false; };
  }, [schedaId, onStatusChange]);

  const eventi = useMemo(() => {
    if (!data) return [];
    return [
      ...(data.eventi || []),
      ...(data.data_creazione ? [{
        id: 'creazione-pratica',
        data_evento: data.data_creazione,
        tipo: 'CREAZIONE',
        descrizione: 'Pratica creata'
      }] : [])
    ]
      .filter(item => tipiVisibili.includes(item.tipo))
      .sort((a, b) => new Date(b.data_evento) - new Date(a.data_evento));
  }, [data]);

  if (!schedaId) return <p>Salva la pratica per consultarne lo storico.</p>;
  if (!data) return <p>{error || 'Caricamento...'}</p>;

  return <section className="workflow-page workflow-readonly">
    <section className="workflow-history-print">
      <header className="workflow-history-header">
        <div>
          <span>PRATICA {data.numero_progressivo || schedaId}</span>
          <h1>Storico attività</h1>
          <p>Registro automatico degli eventi principali della pratica.</p>
        </div>
        <button type="button" onClick={() => window.print()}>Stampa / salva PDF</button>
      </header>
      <div className="workflow-history-list">
        {eventi.length === 0 && <p className="workflow-empty">Nessuna attività registrata.</p>}
        {eventi.map(item => <article className="workflow-history-item" key={`${item.tipo}-${item.id}`}>
          <time>{new Date(item.data_evento).toLocaleString('it-IT', {  dateStyle: 'short', timeStyle: 'short' })}</time>
          <span className={`workflow-event-type workflow-event-${item.tipo.toLowerCase()}`}>
            {etichetteTipo[item.tipo] || item.tipo}
          </span>
          <strong>{item.descrizione}</strong>
          {item.operatore && <small>{item.operatore}</small>}
        </article>)}
      </div>
    </section>
    {error && <p role="alert">{error}</p>}
  </section>;
}
